import { University } from "lucide-react";

export const conferenceInfo = {
  title: "INTERNATIONAL CONFERENCE",
  subtitle:
    "TRANSPORTATION GEOTECHNICS & SUSTAINABLE MATERIALS FOR ADVANCED RESILIENT INFRASTRUCTURE",
  shortName: "(TG-SMART 2026)",
  dates: "OCTOBER 8-10, 2026",
  venue: "Integral University, Lucknow",
};

// CONVENOR AND CO-CONVENORS
export const convenor = {
  name: "Prof. Syed Aqeel Ahmad",
  linkedin:
    "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-CV%20_Dr.%20Syed%20Aqeel%20Ahmad.pdf",
  designation: "Professor & Head, Department of Civil Engineering",
  organization: "Integral University, Lucknow",
  message:
    "As Convener of TG-SMART 2026, it is my privilege to present this international conference as a significant academic and professional forum in the field of transportation geotechnics and sustainable infrastructure. The conference is envisioned to bring together researchers, academicians, industry experts, and policymakers to deliberate on emerging challenges and innovative solutions related to ground improvement, geosynthetics, pavement and subsurface geotechnics, geo-hazards, earthquake geotechnics, and climate-resilient infrastructure. TG-SMART 2026 emphasizes research-driven, sustainable, and field-implementable solutions that address the evolving needs of modern infrastructure development. Through technical sessions, keynote lectures, and industry interactions, the conference aims to foster meaningful knowledge exchange and strengthen collaboration between academia and industry. I warmly invite participants to contribute their research and be part of this collective effort toward building resilient and sustainable infrastructure systems. TG-SMART 2026 provides a high-impact platform for industry leaders to showcase innovative technologies, discuss real-world infrastructure challenges, and collaborate with leading academicians and researchers.",
  image: "/images/convenors/convenor.jpg",
};

export const coConvenors = [
  {
    id: 1,
    name: "Dr. A. P. Singh",
    linkedin: "https://linkedin.com/in/dr-a-p-singh-2525b61a",
    designation: "Honorary Secretary",
    organization: "Indian Geotechnical Society, India",
    phone: "",
    email: "",
    message:
      "TG-SMART 2026 serves as a focused platform for academicians, researchers, and industry professionals to exchange ideas on transportation geotechnics and sustainable materials for resilient infrastructure. The conference emphasizes ground improvement, geosynthetics, pavement and subsurface geotechnics, geo-hazards, earthquake geotechnics, and climate-resilient infrastructure. With a strong orientation toward practical, research-driven, and sustainable solutions, TG-SMART 2026 aims to strengthen academia–industry collaboration and contribute meaningfully to the advancement of modern infrastructure engineering.",
    image: "/images/convenors/co-convenor1.jpg",
  },
  {
    id: 2,
    name: "Dr. Zishan Raza Khan",
    linkedin: "https://www.iul.ac.in/ccgnd/Default.aspx",
    designation: "Associate Professor, Department of Civil Engineering",
    organization: "Integral University, Lucknow",
    phone: "",
    email: "",
    message:
      "TG-SMART 2026 emphasizes research-driven, practical, and field-implementable solutions aligned with national and global infrastructure needs. Through keynote lectures, technical sessions, poster presentations, and industry interactions, the conference seeks to foster meaningful knowledge exchange and strengthen academia–industry collaboration. We warmly invite researchers and professionals to contribute and be part of this intellectually stimulating event.",
    image: "/images/convenors/co-convenor2.jpg",
  },
  {
    id: 3,
    name: "Dr. Yusuf Jamal",
    linkedin: "https://www.linkedin.com/in/yusuf-jamal-9142a8101/",
    designation: "Associate Professor, Department of Civil Engineering",
    organization: "Integral University, Lucknow",
    phone: "",
    email: "",
    message:
      "TG-SMART 2026 places strong emphasis on sustainable construction practices, waste-to-resource materials, advanced testing and monitoring techniques, and data-driven geotechnical solutions with real-world applicability. By fostering interdisciplinary dialogue and industry–academia collaboration, the conference aims to promote research that is both scientifically rigorous and practically implementable. We look forward to welcoming contributors whose work supports resilient, sustainable, and future-ready infrastructure development.",
    image: "/images/convenors/co-convenor3.jpg",
  },
];

// NOTICES WITH PDF LINKS
export const notices = [
  {
    id: 1,
    date: "13-04-2026",
    text: "TGSMART Brochure, (Abstract Extended)",
    pdfUrl: "/pdfs/notices/notice1.pdf",
  },
  {
    id: 2,
    date: "20-04-2026",
    text: "Abstract Template",
    pdfUrl: "/pdfs/notices/notice2.pdf",
  },
  {
    id: 3,
    date: "27-06-2026",
    text: "Full length paper format",
    pdfUrl: "/pdfs/notices/notice3.pdf",
  },
  {
    id: 4,
    date: "28-09-2026",
    text: "Latest Update",
    pdfUrl: "/pdfs/notices/notice4.pdf",
  },
];

// CAROUSEL IMAGES
export const bannerImages = ["/images/banner/slide1.jpg"];

// CAROUSEL IMAGES
export const carouselImages = [
  "/images/carousel/slide1.jpg",
  "/images/carousel/slide2.jpg",
  "/images/carousel/slide3.jpg",
  "/images/carousel/slide4.jpg",
  "/images/carousel/slide5.jpg",
  "/images/carousel/slide6.jpg",
  "/images/carousel/slide7.jpg",
  "/images/carousel/slide8.jpg",
];

export const LINKS = {
  ABOUT_CONFERENCE: "https://tgsmart2026.iul.ac.in/",
  INTEGRAL_UNIVERSITY: "https://iul.ac.in/",
  LUCKNOW_CHAPTER: "https://www.igs.org.in/local-chapter/lucknow",
  CSIR_CBRI: "https://cbri.res.in/",
  CSIR_CRRI: "- https://crridom.gov.in/en",
  CIVIL_DEPT: "https://www.iul.ac.in/CE/Faculty.aspx",
};

// DIGNITARIES
export const chiefPatron = {
  name: "Prof. Syed Waseem Akhtar",
  linkedin: "https://www.iul.ac.in/About/leadership/Chancellor.aspx",
  designation: "Hon'ble Chancellor & Founder",
  organization: "Integral University, Lucknow",
  image: "/images/dignitaries/chiefpatron/chief-patron.jpg",
};

export const patrons = Array.from({ length: 4 }, (_, i) => ({
  id: i + 1,
  name: ` ${["Dr. Syed Nadeem Akhtar", "Mr. Syed M. Fauzan Akhtar", "Mr. Syed Adnan Akhtar", "Dr.  Nida Fatima"][i]} `,
  linkedin: ` ${
    [
      "https://www.iul.ac.in/About/leadership/ProChancellor.aspx",
      "https://www.iul.ac.in/About/leadership/Additional-Pro-Chancellor%E2%80%93IIMSR.aspx",
      "https://www.iul.ac.in/About/leadership/Additional-Pro-Chancellor%E2%80%93IIPSR.aspx",
      "https://www.iul.ac.in/About/leadership/Additional-Pro-Chancellor%E2%80%93ISF-CIED.aspx",
    ][i]
  } `,
  designation: ` ${["Hon'ble Pro Chancellor", "Hon'ble Additional Pro Chancellor", "Hon'ble Additional Pro Chancellor", "Hon'ble Additional Pro Chancellor"][i]} `,
  organization: "Integral University",
  image: `/images/dignitaries/patrons/patron${i + 1}.jpg`,
}));

export const conferenceChair = Array.from({ length: 4 }, (_, i) => ({
  id: i + 1,
  name: ` ${["Prof. Furqan Qamar", "Prof. Pradeep Kr. Ramancharla", "Prof. Chalumuri Ravi Sekhar", "Dr. Anil Joseph"][i]} `,
  linkedin: ` ${
    [
      "https://www.iul.ac.in/About/leadership/ViceChancellor.aspx",
      "https://cbri.res.in/prof-ramancharla-pradeep-kumar",
      "https://crridom.gov.in/en/director-crri",
      "https://www.igs.org.in/members/dr-anil-joseph1",
    ][i]
  } `,
  designation: ` ${["Hon'ble Vice Chancellor", "Director", "Director", "President"][i]} `,
  organization: ` ${["Integral University", "CSIR-CBRI, Roorkee", "CSIR-CRRI, New Delhi", "Indian Geotechnical Society"][i]} `,
  image: `/images/dignitaries/conchair/chair${i + 1}.jpg`,
}));

export const coPatrons = Array.from({ length: 26 }, (_, i) => ({
  id: i + 1,
  name: ` ${["Prof. Mohammad Haris Siddiqui", "Prof. Abdul Rahman Khan", "Prof. Sunil Kumar", "Prof. Wahajul Haq", "Dr. Mohd Atif Siddiqui", "Prof. Mohammad Faisal", "Prof. Alvina Farooqui", "Prof. Saba Siddiqui", "Dr. Mohammad Sufian Abbasi", "Dr. Syed Belal Hassan", "Dr. Tariq Mahmood", "Mr. Parvez Ahmad Khan", "Mr. Ahmad Raza", "Shri Ashok Kumar Dwivedi", "Shri Mukesh Chand Sharma", "Shri Vijai Kanaujia", "Sri. Devendra Singh", "Sri. D D Pathak", "Shri Ram Nath Singh", "Shri Dharm Veer Singh", "Shri Ramesh Chandra (IAS)", "Shri Sandeep Kumar", "Shri Ashok Kumar Singh", "Mr. Vinod Kr Srivastava", "Er. Ashish Yadav", "Mr. Brijesh Dubey"][i]}`,
  linkedin: ` ${
    [
      "https://www.iul.ac.in/About/leadership/Registrar.aspx",
      "https://www.iul.ac.in/About/leadership/ControllerExaminations.aspx",
      "https://www.iul.ac.in/Engineering",
      "https://linkedin.com/in/wahajul-haq-a73ba2215",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Electrical%20Engineering/_Electrical%20Engineering-CV_Dr.%20M%20A%20Siddiqui_EED.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Computer%20Application/_Computer%20Application-Dr%20Mohammad%20Faisal_ShortCV.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Bioengineering/_Bioengineering-CV_For_Deptt_Website_Template-1.pdf",
      "https://iiast.iul.ac.in/Faculty-Details.aspx?FId=454",
      "https://www.linkedin.com/in/er-mohd-sufian-abbasi-7b4576252",
      "https://www.linkedin.com/in/syed-hassan-54285515",
      "",
      "",
      "",
      "https://uppwd.gov.in/en/deptofficer",
      "https://uppwd.gov.in/en/deptofficer",
      "https://uppwd.gov.in/en/deptofficer",
      "",
      "https://www.linkedin.com/in/er-d-d-pathak-85492b294",
      "https://www.uprnn.upsdc.gov.in/en/page/technical-team",
      "https://www.linkedin.com/in/dharm-veer-singh-487537309",
      "http://www.cst.up.gov.in",
      "https://dmpidup.com",
      "https://dmpidup.com",
      "https://www.linkedin.com/in/ashok-kumar-singh-b1990647",
      "https://www.linkedin.com/in/ashish-yadav-b3341240",
      "https://www.linkedin.com/in/brijesh-dubey-704858a9",
    ][i]
  } `,
  designation: ` ${["Registrar", "Controller of Examination", "Dean, Engineering & IT", "Dean, R&D", "Addl. Director(Admission & Academics) & Head, Dept. of Electrical Engineering", "Provost & Head, Dept. of Computer Application", "Convenor Academic Program & Research Committee & Head, Dept. Of Bioengineering", "Head, Dept. of Agriculture", "Director,Procurement", "Director, IIMSR", "Professor & Head", "Professor of Practice", "Treasurer", "Engineer in Chief (Development) & Head", "Engineer in Chief (Rural Roads)", "Engineer in Chief (Design & Planning)", "State Quality Coordinator (SQC)/Dy. CEO", "State Technical Officer (STO)", "MD", "MD", "Director", "Engineer in Chief & Head", "Engineer in Chief (D&P)", "President", "National Secretary General & General Secretary", "Senior Engineer/Chief Engineer"][i]}`,
  organization: ` ${["Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "Integral University", "UPPWD", "UPPWD", "UPPWD", "PMGSY", "PMGSY", "UP Rajkiya Nirman Nigam, Lucknow", "UP State Bridge Corporation Ltd, Lucknow", "CST, U.P.", "Irrigation & Water Resource Dept, Lucknow", "Irrigation & Water Resource Dept, Lucknow", "UP Engineers Association", "Indian Engineers Federation(INDEF) & UP Engineers Association", "UPRRDA, Lucknow"][i]} `,
  image: `/images/dignitaries/copatrons/co-patron${i + 1}.jpg`,
}));

// COMMITTEE MEMBERS
export const organizingCommittee = Array.from({ length: 6 }, (_, i) => ({
  id: i + 1,
  name: `${["Dr. Manojit Samanta", "Dr. Ravi Shankar S.", "Dr. Vikash Singh", "Dr. Vinay Bhushan Chauhan", "Dr. Sarfaraz Ahmed", "Dr. Utkarsh Mishra"][i]}`,
  linkedin: ` ${
    [
      "https://www.linkedin.com/in/manojit-samanta-6288b554",
      "https://www.linkedin.com/in/dr-ravi-shankar-s-038827163",
      "linkedin.com/in/vikash-singh-6292b3334",
      "https://sites.google.com/view/vbciitb/education",
      "https://www.linkedin.com/in/sarfaraz-ahmed-ph-d-463350a4",
    ][i]
  } `,
  designation: ` ${["Senior Principal Scientist", "Senior Scientist", "Assistant Professor and Treasurer", "Assistant Professor", "Senior Scientist", "Assistant Professor"][i]}`,
  organization: `${["CSIR CBRI, Roorkee", "CSIR CRRI, New Delhi", "CED, IET and IGS Lucknow Chapter ", "CED, MMMUT Gorakhpur and Honorary Secretary IGS Lucknow Chapter", "CSIR CRRI, New Delhi", "Integral University"][i]}`,
  image: `/images/committee/organizing/member${i + 1}.jpg`,
}));
export const jointorganizingCommittee = Array.from({ length: 4 }, (_, i) => ({
  id: i + 1,
  name: `${
    [
      "Dr. K. Venkatesh",
      "Dr. Aayush Kumar",
      "Mr. Shamim Ahmad",
      "Mr. Harshit Srivastava",
    ][i]
  }`,
  linkedin: ` ${
    [
      "https://mnnit.ac.in/profile/venkatesh",
      "https://sites.google.com/view/info-aayush/home",
      "https://www.linkedin.com/in/shameem-ahmad-1533005b",
      "https://www.linkedin.com/posts/harshit-kumar-srivastava-826540168",
    ][i]
  } `,
  designation: ` ${["Professor", "Assistant Professor", "Field Director", "Technical Director"][i]}`,
  organization: `${["CED, MNNIT Allahabad", "CED, KMC Language University, Lucknow", "Arun Soil Lab Pvt. Ltd., Lucknow", "Arun Soil Lab Pvt. Ltd., Lucknow"][i % 4]}`,
  image: `/images/committee/jointorganizing/member${i + 1}.jpg`,
}));

export const advisoryCommittee = Array.from({ length: 36 }, (_, i) => ({
  id: i + 1,
  name: `${
    [
      "Dr. Brij Kishor Pandey",
      "Dr. Lindung Zalbuin Mase",
      "Dr. Saif Alzabeebee",
      "Dr. Krishna R. Reddy",
      "Dr. Prabir K Kolay",
      "Dr. Sanjay Nimbalkar",
      "Dr. Adewole Oladele",
      "Dr. Tatsuya Ishikawa",
      "Dr. S.K. Shukla",
      "Dr. T.G. Sitharam",
      "Dr. A. Murali Krishna",
      "Dr. Amarnath Hegde",
      "Dr. Arindam Dey",
      "Dr. C.R. Parthasarathy",
      "Dr. Kala Venkata Uday",
      "Dr. Madhavi Latha Gali",
      "Dr. Mahendra Singh",
      "Dr. Sunita Kumari",
      "Dr. Ankit Gupta",
      "Dr. B.A. Mir",
      "Dr. B. Munwar Basha",
      "Dr. Brind Kumar",
      "Dr. Deepankar Choudhury",
      "Dr. Dharamveer Singh",
      "Prof. G.L. Sivakumar Babu",
      "Dr. Jagdish Prasad Sahoo",
      "Dr. M.R. Madhav",
      "Dr. N.K. Samadhiya",
      "Dr. Neelima Satyam",
      "Dr. P.K. Agarwal",
      "Dr. Anbazhagan P",
      "Dr. Ravi Sundaram",
      "Dr. Shoeb Malik",
      "Dr. V.B. Maji",
      "Dr. T.N. Singh",
      "Mr. Niranjan Singh",
    ][i]
  }`,
  linkedin: ` ${
    [
      "https://www.bits-pilani.ac.in/dubai/brij-kishor-pandey/",
      "https://engineering.unib.ac.id/bce/lecturers/",
      "https://www.linkedin.com/in/saif-alzabeebee-phd-b4153358",
      "https://cme.uic.edu/profiles/krishna/",
      "https://faculty.siu.edu/profiles/j-l/kolay-prabir.php",
      "https://profiles.uts.edu.au/Sanjay.Nimbalkar",
      "https://www.nust.na/prof-adewole-simon-oladele",
      "https://www.eng.hokudai.ac.jp/labo/geomech/english/member/",
      "https://www.ecu.edu.au/schools/engineering/staff/profiles/associate-professors/associate-professor-sanjay-kumar-shukla",
      "http://tgsitharam.com",
      "https://iittp.ac.in/dr-a-murali-krishna",
      "https://www.iitdh.ac.in/user-profile/amarnath-hegde",
      "https://www.iitg.ac.in/arindam.dey/homepage/index.html",
      "https://www.linkedin.com/in/dr-cr-parthasarathy-1298896",
      "https://www.linkedin.com/in/venkata-uday-kala-%E0%A4%95%E0%A4%B2%E0%A4%BE-%E0%B0%95%E0%B3%B3-09417315",
      "https://civil.iisc.ac.in/people/madhavi-latha-g/",
      "https://www.linkedin.com/in/mahendra-singh-725a5a64",
      "https://www.linkedin.com/in/prof-dr-sunita-kumari-9324641a7",
      "https://www.iitbhu.ac.in/dept/civ/people/ankitciv",
      "https://igs.org.in/member/prof-bashir-ahmed-mir",
      "https://iith.ac.in/ce/basha/",
      "https://www.iitbhu.ac.in/dept/civ/people/kumarbrindciv",
      "https://www.civil.iitb.ac.in/faculty/details/prof-deepankar-choudhury-fnae-fnasc-fasc-f-asce",
      "https://www.civil.iitb.ac.in/faculty/details/prof-dharamveer-singh",
      "https://civil.iisc.ac.in/~gls/",
      "https://sites.google.com/view/jagdish-prasad-sahoo",
      "https://home.iitk.ac.in/~madhav/",
      "https://scholar.google.com/citations?user=BwZb9e0AAAAJ&hl=en",
      "https://www.igs.org.in/member/dr-d-neelima-satyam",
      "https://systems.enpress-publisher.com/index.php/TM/about/editorialTeamBio/14595",
      "https://www.civil.iisc.ac.in/people/anbazhagan-p/",
      "https://www.linkedin.com/in/ravi-sundaram-78745b15",
      "https://scholar.google.com/citations?user=7vJ-aqoAAAAJ&hl=en",
      "https://civil.iitm.ac.in/faculty/vbmaji/",
      "https://www.iitp.ac.in/~tns/profile.html",
      "https://www.linkedin.com/in/niranjan-singh-6b5ba023",
    ][i]
  } `,
  designation: `${
    [
      "Assistant Professor & Head",
      "Professor",
      "Associate Professor",
      "Professor",
      "Director & Professor",
      "Associate Professor",
      "",
      "Chair, ISSMGE TC202 Transportation Geotechnics",
      "Professor",
      "Professor",
      "Professor",
      "Professor",
      "Associate Professor",
      "Director",
      "Professor",
      "Professor",
      "Professor",
      "Professor & Head",
      "Professor",
      "Professor",
      "Professor",
      "Professor",
      "Professor",
      "Professor",
      "Retd. Professor",
      "Associate Professor",
      "Emeritus Professor",
      "Professor",
      "Professor",
      "Professor",
      "Professor",
      "Director",
      "Professor",
      "Professor",
      "Director",
      "Chairman",
    ][i]
  }`,
  organization: `${
    [
      "BITS Pilani, UAE Campus",
      "University of Bengkulu, Indonesia ",
      "University of Al-Qadisiyah Al- Qadisiyah, Iraq",
      "University of Illinois Chicago (UIC), USA",
      "Southern Illinois University, Carbondale, USA",
      "University of Technology Sydney, Australia",
      "National University of Sciences & Technology, West Indies",
      "Hokkaido University, Japan",
      "Edith Cowan University, Perth, Australia",
      "Indian Institute of Science, Bengaluru",
      "Indian Institute of Technology, Tirupati",
      "Indian Institute of Technology, Dharwad",
      "Indian Institute of Technology, Guwahati",
      "Sarathy Lab Pvt. Ltd., Bengaluru ",
      "Indian Institute of Technology, Mandi ",
      "Indian Institute of Science, Bangalore ",
      "Indian Institute of Technology, Roorkee",
      "National Institute of Technology, Patna ",
      "Indian Institute of Technology (BHU) Varanasi ",
      "National Institute of Technology, Srinagar",
      "Indian Institute of Technology, Hyderabad",
      "Indian Institute of Technology (BHU) Varanasi",
      "Indian Institute of Technology, Bombay ",
      "Indian Institute of Technology, Bombay",
      "Indian Institute of Science, Bengaluru",
      "Indian Institute of Technology Kanpur",
      "Indian Institute of Technology, Hyderabad",
      "Indian Institute of Technology, Roorkee",
      "Indian Institute of Technology, Indore",
      "Maulana Azad National Institute of Technology, Bhopal",
      "Indian Institute of Science, Bengaluru",
      "Cengrs Geotechnica Pvt. Ltd., Noida",
      "Aligarh Muslim University, Aligarh",
      "Indian Institute of Technology, Madras",
      "Indian Institute of Technology, Patna ",
      "Arun Soil Lab, Lucknow",
    ][i]
  }`,
  image: `/images/committee/advisory/member${i + 1}.jpg`,
}));

export const technicalCommittee = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  name: `${
    [
      "Dr. R. P. Singh",
      "Dr. Arif Ali Baig Moghal",
      "Dr. Sreevalsa Kolathayar",
      "Dr. Gottumukkala Bharath",
      "Dr. Baadiga Ramu",
      "Dr. Ankesh Kumar",
      "Dr. Avinash Kumar Singh",
      "Dr. Vijay Kumar",
      "Dr. Aditya Kumar Das",
      "Mr. Shashank Bhatnagar",
      " Dr. Pawan Kumar Chamling",
      "Dr. Amit Srivastava",
    ][i]
  }`,
  linkedin: ` ${
    [
      "https://www.linkedin.com/in/dr-raghvendra-pratap-singh-4413a313",
      "https://erp.nitw.ac.in/ext/profile/ce-baig",
      "https://civil.nitk.ac.in/professor/sreevalsa-kolathayar",
      "https://www.linkedin.com/in/dr-bharath-gottumukkala-0b124a9b",
      "https://sites.google.com/view/ramubaadiga",
      "https://iitpkd.ac.in/people/ankesh",
      "https://people.iitism.ac.in/~download/cv/1418/1418.pdf",
      "https://mnnit.ac.in/profile/previewr.php?id=1797",
      "https://www.nitrkl.ac.in/FacultyStaff/FacultyProfile/?id=dasaditya",
      "https://in.linkedin.com/in/shashank-bhatnagar-459331192",
      "https://www.linkedin.com/in/pawan-kumar-chamling-21781865?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/dr-amit-srivastava-770b15147/",
    ][i]
  } `,
  designation: `${
    [
      "Joint General Manager",
      "Professor",
      "Associate Professor",
      "Principal Scientist",
      "Assistant Professor",
      "Assistant Professor",
      "Assistant Professor",
      "Assistant Professor",
      "Assistant Professor",
      "Scientist",
      "Assistant Professor",
      "Professor",
    ][i]
  }`,
  organization: `${["NHSRCL", "CED, NIT Warangal", "NIT Karnataka, Surathkal", "CSIR CRRI, New Delhi", "Civil Department, IIT Indore", "CED, IIT Palakkad", "CED, IIT(ISM) Dhanbad", "CED, MNNIT Allahabad", "CED, NIT Rourkela", "CSIR CBRI, Roorkee", "NIT Andhra Pradesh", "CED, Graphic Era (Deemed to be) University, Dehradun"][i]}`,
  image: `/images/committee/technical/member${i + 1}.jpg`,
}));

//website committee
export const websiteCommittee = Array.from({ length: 4 }, (_, i) => ({
  id: i + 1,
  name: `${
    [
      "Prof. Mohammad Faisal",
      "Dr. Vikash Singh",
      "Mr. Abdullah Aqeel",
      "Mr. Mohd. Tanveer",
    ][i]
  }`,
  linkedin: ` ${
    [
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Computer%20Application/_Computer%20Application-Dr%20Mohammad%20Faisal_ShortCV.pdf",
      "https://linkedin.com/in/vikash-singh-6292b3334",
      "https://www.linkedin.com/in/abdullah-aqeel-b4080228a",
      "",
    ][i]
  } `,
  designation: ` ${["Provost & Head", "Assistant Professor & Treasurer", "Lab Instructor", "Office Assistant"][i]}`,
  organization: `${["CA Dept., Integral University", "CED, IET and IGS Lucknow Chapter", "CA Dept, Integral University", "CED, Integral University"][i % 4]}`,
  image: `/images/committee/website/member${i + 1}.jpg`,
}));

//programme committee
export const programmeCommittee = Array.from({ length: 30 }, (_, i) => ({
  id: i + 1,
  name: `${
    [
      "Dr. Neha Mumtaz",
      "Dr. Yusuf Jamal",
      "Mr. Mohd. Kashif Khan",
      "Dr. Tabish Izhar",
      "Dr. Mohd Sadat",
      "Mr. Mohd Asim",
      "Mr. Faraz Hasan Qadri",
      "Dr. Ahmad Rashiq",
      "Mr. Mohd Yaqoob",
      "Sumit Kumar Chaudhary",
      "Mr. Rajat Verma",
      "Mr. Mohammad Riyaz",
      "D. K. Singh",
      "Usman Ali",
      "Amresh Yadav",
      "Hamza Imran",
      "Maaz Arshad",
      "Nabeel Ahmad",
      "Ruban Khan",
      "Arshad Hameed",
      "Manubolu Monica Sree",
      "Prakhar Tyagi",
      "Ujjawal Srivastava",
      "Manoo Singh",
      "Shahbaz Ahmad Mir",
      "Ahmad Hamza Kazmain",
      "Jamia Hassan",
      "Mohammad Danish",
      "Aaqil Ahmad",
      "Swastik Nigam",
    ][i]
  }`,
  linkedin: ` ${
    [
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-Dr.%20Neha%20Mumtaz.pdf",
      "https://www.linkedin.com/in/yusuf-jamal-9142a8101/",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-Mr.%20Mohd%20Kashif%20Khan.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-Dr.%20Tabish%20Izhar.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-Dr.%20Mohd%20Sadat.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-Mr.%20Mohd%20Asim.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_Civil%20Engineering-CV_Faraz%20Hasan%20Qadri.pdf",
      "https://www.iul.ac.in/DWC/Faculty/fileupload/Civil%20Engineering/_F01402-134173341135131247CV%20Ahmad%20Rashiq.pdf",
      "https://www.iul.ac.in/CE/SupportingStaff.aspx",
      "https://www.iul.ac.in/CE/SupportingStaff.aspx",
      "https://www.iul.ac.in/CE/SupportingStaff.aspx",
      "https://www.iul.ac.in/CE/SupportingStaff.aspx",
      "https://www.linkedin.com/in/ahmad-hamza-kazmain?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/ahmad-hamza-kazmain?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/ahmad-hamza-kazmain?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/hamza-imran-2468b0176?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      "https://www.linkedin.com/in/maaz-arshad-136b65336?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      "https://www.linkedin.com/in/nabeel-ahmad-846b38232",
      "https://www.linkedin.com/in/ruban-khan-0375802b2/?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      "https://www.linkedin.com/in/arshad-hameed-012644351?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/manubolu-monicasree-41829b241",
      "https://www.igs.org.in/local-chapter/lucknow",
      "https://www.igs.org.in/local-chapter/lucknow",
      "https://www.linkedin.com/in/manoo-singh-338667149?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/mirshahbazahmad",
      "https://www.linkedin.com/in/ahmad-hamza-kazmain?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "https://www.linkedin.com/in/jamia-hasan-1529b9277",
      "https://www.linkedin.com/in/mohammad-danish-9001b6286?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      "https://www.linkedin.com/in/aaqil-ahmad-0b04002a5?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
      "https://www.linkedin.com/in/swastik-nigam-0b207b331?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    ][i]
  } `,
  designation: ` ${
    [
      "Associate Professor",
      "Associate Professor",
      "Associate Professor",
      "Associate Professor",
      "Assistant Professor",
      "Assistant Professor",
      "Assistant Professor",
      "Assistant Professor",
      "Senior Lab Instructor",
      "Lab Instructor",
      "Lab Instructor",
      "Lab Instructor",
      "Research Scholar",
      "Research Scholar",
      "Research Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "M. Tech Scholar",
      "B.Tech. Student",
      "B.Tech. Student",
      "B.Tech. Student",
      "B.Tech. Student",
      "B.Tech. Student",
    ][i]
  }`,
  organization: `${
    [
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
      "CED, Integral University",
    ][i]
  }`,
  image: `/images/committee/programme/member${i + 1}.jpg`,
}));

// SPEAKERS WITH IMAGES (8 each)
export const keynoteSpeakers = Array.from({ length: 11 }, (_, i) => ({
  id: i + 1,
  name: `${
    [
      "Prof. Tatsuya Ishikawa",
      "Dr. Lindung Zalbuin Mase",
      "Dr. Praveen Kumar",
      "Dr. M. Amaranatha Reddy",
      "Dr. Neelima Satyam Devarakonda",
      "Dr. Arif Ali Baig Moghal",
      "Dr. Kanwar Singh",
      "Dr. Ramanathan Ayothiraman",
      "Dr. Ambika Behl",
      "Dr. R. P. Singh",
      "Dr. Sreevalsa Kolathayar",
    ][i]
  }`,
  linkedin: ` ${
    [
      "https://www.eng.hokudai.ac.jp/labo/geomech/english/member/",
      "https://engineering.unib.ac.id/bce/lecturers/",
      "https://civil.iitr.ac.in/CE?Uid=pkaerfce",
      "https://www.iitkgp.ac.in/department/CE/faculty/ce-manreddy",
      "https://people.iiti.ac.in/~neelima.satyam/",
      "https://www.linkedin.com/in/dr-arif-ali-baig-moghal-1b815449/",
      "https://www.linkedin.com/in/kanwar-singh-12a517aa/",
      "https://old.iittp.ac.in/prof-ramanathan-ayothiraman",
      "https://crridom.gov.in/en/node/543",
      "https://www.linkedin.com/in/nikhil-saboo-330ab856/",
      "https://www.linkedin.com/in/sreevalsa-kolathayar-36164826/",
    ][i]
  } `,
  designation: `${["Professor & Chair", "Professor", "Professor", "Professor", "Professor", "Professor", "Chief Scientist & Head", "Professor", "Senior Principal Scientist", "Joint General Manager (Civil)", "Associate Professor"][i]}`,
  organization: `${["Hokkaido University, Japan & ISSMGE (Tc202)", "University of Bengkulu, Indonesia ", "IIT Roorkee", "IIT Kharagpur", "IIT Indore", "NIT Warangal", "CSIR-CRRI, New Delhi", "IIT Tirupati", "CSIR-CRRI, New Delhi", "National High Speed Rail Corporation Limited, Mumbai", "NIT Karnataka, Surathkal"][i]}`,
  image: `/images/speakers/keynote/speaker${i + 1}.jpg`,
}));

export const invitedSpeakers = Array.from({ length: 4 }, (_, i) => ({
  id: i + 1,
  name: `${["TBD", "TBD", "TBD", "TBD"][i]}`,
  linkedin: ` ${["", ""][i]} `,
  designation: "Invited Speaker",
  organization: `${[][i]}`,
  image: `/images/speakers/invited/speaker${i + 1}.jpg`,
}));

export const sessionChairs = Array.from({ length: 4 }, (_, i) => ({
  id: i + 1,
  name: `${["TBD", "TBD", "TBD", "TBD"][i]}`,
  linkedin: ` ${["", "", "", ""][i]} `,
  designation: "Session Chair",
  organization: `${["TBD", "TBD", "TBD", "TBD"][i]}`,
  image: `/images/speakers/chairs/speaker${i + 1}.jpg`,
}));

// CALL FOR PAPERS WITH PDF AND GOOGLE FORM
export const callConfig = {
  abstract: {
    pdfUrl: "/pdfs/call/Abstract_temp.pdf",
    googleFormUrl: "https://forms.gle/jx72FZYdVw1x43eg6",
  },
  papers: {
    pdfUrl: "/pdfs/call/abstract.pdf",
    googleFormUrl: "https://forms.gle/your-papers-form-link",
  },
  oral: {
    pdfUrl: "/pdfs/call/abstract.pdf",
    googleFormUrl: "https://forms.gle/your-oral-form-link",
  },
  poster: {
    pdfUrl: "/pdfs/call/abstract.pdf",
    googleFormUrl: "https://forms.gle/your-poster-form-link",
  },
};

export const bankingDetails = {
  accountNumber: "1854010100004840",
  holderName: "Integral University",
  bankName: "Punjab National Bank",
  branch: "Dasauli, Kursi Road, Lucknow",
  ifscCode: "PUNB0478600",
  MICRcode: "226024038",
  swiftCode: "PUNBINBBLHT",
};

export const registrationFormUrl = " https://tgsmart2026.iul.ac.in/Register/";

// SPONSORSHIP
export const sponsorshipTiers = [
  { id: 1, title: "Title Sponsor", amount: "₹3,50,000" },
  { id: 2, title: "Platinum Sponsor", amount: "₹2,50,000" },
  { id: 3, title: "Diamond Sponsor", amount: "₹1,75,000" },
  { id: 4, title: "Gold Sponsor", amount: "₹1,25,000" },
  { id: 5, title: "Silver Sponsor", amount: "75,000" },
  { id: 6, title: "Bronze Sponsor", amount: "50,000" },
  { id: 7, title: "Well Wisher", amount: "25,000" },
];

export const sponsorshipdetails = "/pdfs/call/sponsor.pdf";

export const sponsorTiers = [
  {
    name: "Diamond",
    files: ["sponsord1.jpeg", "sponsord2.jpeg", "sponsord3.jpeg"],
  },
  {
    name: "Gold",
    files: [
      "sponsorg1.jpeg",
      "sponsorg2.jpeg",
      "sponsorg3.jpeg",
      "sponsorg4.jpeg",
      "sponsorg5.jpeg",
    ],
  },
  {
    name: "Silver",
    files: ["sponsors1.jpeg", "sponsors2.jpeg"],
  },
  {
    name: "Bronze",
    files: [
      "sponsorb1.jpeg",
      "sponsorb2.jpeg",
      "sponsorb3.jpeg",
      "sponsorb4.jpeg",
      "sponsorb5.jpeg",
      "sponsorb6.jpeg",
      "sponsorb7.jpeg",
      "sponsorb8.jpeg",
    ],
  },
  {
    name: "Wellwisher",
    files: [
      "sponsorw1.jpeg",
      "sponsorw2.jpeg",
      "sponsorw3.jpeg",
      "sponsorw4.jpeg",
      "sponsorw5.jpeg",
      "sponsorw6.jpeg",
      "sponsorw7.jpeg",
    ],
  },
];

// CONTACT INFO
export const contactInfo = {
  organization: "Integral University, Lucknow",
  address: "Kursi Road, Lucknow, Uttar Pradesh 226026, India",
  email: "tgsmart2026@iul.ac.in",
  phone: "+91-8707870833, +91-9415985237, +91-9026074042",
  website: "https://tgsmart2026.iul.ac.in",
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3556.2936020600996!2d80.99722207639087!3d26.9576001581583!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3999590399bccd65%3A0xab4963c8a090842d!2sCentral%20Auditorium%2C%20Integral%20University!5e0!3m2!1sen!2sin!4v1791175389870!5m2!1sen!2sin",
};

// SOCIAL MEDIA LINKS
export const socialMediaLinks = {
  facebook: "https://facebook.com/tgsmart2026",
  twitter: "https://twitter.com/tgsmart2026",
  linkedin: "https://linkedin.com/company/tgsmart2026",
  instagram: "https://instagram.com/tgsmart2026",
  youtube: "https://youtube.com/@tgsmart2026",
};

// GALLERY
export const galleryImages = Array.from(
  { length: 10 },
  (_, i) => `/images/gallery/gallery${i + 1}.jpg`,
);

// ABOUT CONTENT
export const aboutContent = {
  aboutConference: {
    title: "TG-SMART CONFERENCE",
    text: "The International Conference on Transportation Geotechnics and Sustainable Materials for Advanced Resilient Infrastructure (TG-SMART 2026) aims to bring together academicians, researchers, industry professionals, and policymakers to deliberate on emerging challenges and innovations in transportation geotechnics and sustainable infrastructure. The conference will focus on ground improvement, geosynthetics, waste-to- resource materials, geo-hazards, computational geotechnics, and climate- resilient infrastructure. Through technical sessions, industry interactions, poster presentations, and keynote lectures by eminent experts. TG-SMART 2026 seeks to promote research-driven, practical, and sustainable solutions for future infrastructure development.",
    image: "/images/about/logo.jpg",
  },
  integralUniversity: {
    title: "INTEGRAL UNIVERSITY, LUCKNOW",
    text: "Integral University is a premier university in Lucknow, the capital city of the state of Uttar Pradesh, India. It was established under the Act Number 9 of 2004 by the State Government. The University is duly approved by the overnme University Grants Commission (UGC) undersections 2(f) and 12B of the UGC Act, 1956, Medical Council of India, Pharmacy Council of India, Indian Nursing Council, Council of Architecture, Bar Council of India, Indian Association of Physiotherapists, National Council for Teacher Education, UP State Medical Faculty and Distance Education Bureau. Integral University is accredited by NAAC(A+) and recognized as a Scientific &Industrial Research Organization (SIRO) & Public Funded Research Institution (PFRI) by the Department of Scientific & Industrial Research, Ministry of Science & Technology, Government of India.",
    image: "/images/about/integral-university.jpg",
  },
  lucknowChapter: {
    title: "IGS, LUCKNOW CHAPTER",
    text: "The IGS Lucknow Chapter is an active local chapter of the Indian Geotechnical Society, with professional and engineers from academia and industry collaborating to promote geotechnical engineering in the region. The chapter currently has 27 members and engages in knowledge-sharing activities and professional networking. It's the 56th chapter of Indian Geotechnical Society. Prof. Syed Aqeel Ahmad serves as the Chairman of this chapter. The IGS Lucknow Chapter provides a platform for members to participate in technical discussions and contribute to the broader geotechnical community.",
    image: "/images/about/lucknow-chapter.jpg",
  },
  csirCbri: {
    title: "CSIR-CENTRAL BUILDING RESEARCH INSTITUTE",
    text: "The Central Building Research Institute (CBRI), Roorkee, a constituent laboratory of CSIR, is India's premier national institute dedicated to building science and technology. Established in 1947, CBRI undertakes comprehensive R&D in building materials, foundations, structural safety, disaster mitigation, fire engineering, and energy-efficient housing. As a collaborator with academic institutions and industry alike, CBRI's inclusion through an MoU adds tremendous value bringing world-class research, sustainable construction technologies, and practical industry-ready solutions that align closely with modern civil engineering education and infrastructure development needs.",
    image: "/images/about/csir-cbri.jpg",
  },
  csirCrri: {
    title: "CSIR-CENTRAL ROAD RESEARCH INSTITUTE",
    text: "The CSIR-Central Road Research Institute (CRRI), New Delhi, a constituent laboratory of the Council of Scientific and Industrial Research (CSIR), is India's premier national institute dedicated to road and transportation research. Established in 1952, CRRI has played a pivotal role in advancing pavement engineering, traffic and transportation planning, geotechnics, bridge engineering, road safety, and sustainable infrastructure development. The institute actively supports national highway development through innovative technologies, performance-based materials, recycling of industrial wastes, and carbon-neutral construction practices. With strong linkages to academia, industry, and government agencies, CSIR-CRRI provides research-driven, field-implementable solutions aligned with modern transportation infrastructure needs.",
    image: "/images/about/csir-crri.jpg",
  },
  civilDept: {
    title: "CIVIL ENGINEERING DEPARTMENT, INTEGRAL UNIVERSITY",
    text: "The Department of Civil Engineering, Integral University, Lucknow, offers B.Tech., M.Tech., and Ph.D. programs with a strong focus on industry- aligned education and research. The Department runs an industry-led B.Tech. program in collaboration with L&T EduTech, supported by immersive learning, internships, and site exposure. It hosts a Centre of Excellence on Sustainable Building Materials with Ultra Tech Cement Ltd. and has MoUs with CSIR-CBRI, Roorkee. Equipped with advance NABL-accredited laboratories, the Department actively undertakes consultancy, testing, and research to support sustainable and resilient infrastructure development.",
    image: "/images/about/civil-dept.jpg",
  },
};

export const registrationFees = [
  {
    category: "Delegates from Industry/Govt. Organization",
    earlyBirdIGS: "₹7000",
    earlyBirdNonIGS: "₹8000",
    regularIGS: "₹8000",
    regularNonIGS: "₹9000",
    foreign: "$100",
  },
  {
    category: "Academician/Faculty Members/Scientist",
    earlyBirdIGS: "₹5000",
    earlyBirdNonIGS: "₹6000",
    regularIGS: "₹6000",
    regularNonIGS: "₹7000",
    foreign: "$100",
  },
  {
    category: "Research Scholar",
    earlyBirdIGS: "₹4000",
    earlyBirdNonIGS: "₹5000",
    regularIGS: "₹5000",
    regularNonIGS: "₹6000",
    foreign: "$80",
  },
  {
    category: "UG/PG Students",
    earlyBirdIGS: "₹3000",
    earlyBirdNonIGS: "₹3500",
    regularIGS: "₹3500",
    regularNonIGS: "₹4000",
    foreign: "$50",
  },
  {
    category: "Accompanying Person/Spouse",
    earlyBirdIGS: "₹2500",
    earlyBirdNonIGS: "₹2500",
    regularIGS: "₹3000",
    regularNonIGS: "₹3000",
    foreign: "$50",
  },
];

export const contactperson = [
  {
    id: 1,
    name: "Dr. Zishan Raza Khan",
    linkedin: "",
    designation: "Associate Professor",
    organization: "Integral University, Lucknow",
    phone: "+91-9450706026",
    image: "/images/contactperson/cop4.jpg",
  },
  {
    id: 2,
    name: "Dr. Vikash Singh",
    linkedin: "",
    designation: "Assistant Professor",
    organization: "IET, Lucknow",
    phone: "+91-8707870833",
    image: "/images/contactperson/cop1.jpg",
  },
  {
    id: 3,
    name: "Dr. Aayush Kumar",
    linkedin: "",
    designation: "Assistant Professor",
    organization: "KMC Language University, Lucknow",
    phone: "+91-9415985237",
    image: "/images/contactperson/cop2.jpg",
  },
  {
    id: 4,
    name: "Mr. Harshit Srivastava",
    linkedin: "",
    designation: "Technical Director",
    organization: "Arun Soil Lab, Lucknow",
    phone: "+91-9026074042",
    image: "/images/contactperson/cop3.jpg",
  },
];

export const accommodations = [
  {
    id: 1,
    name: "Park Inn by Radisson",
    address: "Sector 14, Vikas Nagar, Lucknow",
    website: "https://www.radissonhotels.com",
    websiteLabel: "www.radissonhotels.com",
    phone: "7317500241",
    deluxe: 4500,
    executive: 4500,
  },
  {
    id: 2,
    name: "Vijay Paradise",
    address: "Ring Road, Vikas Nagar, Lucknow 226022",
    website: "https://www.vijayparadise.in",
    websiteLabel: "www.vijayparadise.in",
    phone: "7318099205",
    deluxe: 3500,
    executive: 4200,
  },
  {
    id: 3,
    name: "Sapna Clarks Inn",
    address: "CP-3, Sector 11, Vikas Nagar, Ring Road, Lucknow",
    website: "https://www.theclarkshotels.com",
    websiteLabel: "www.theclarkshotels.com",
    phone: "7408415950",
    deluxe: 3500,
    executive: 4000,
  },
  {
    id: 4,
    name: "The Royal Legacy",
    address: "CP5/1A, Vikas Nagar, Lucknow",
    website: "https://www.theroyallegacy.in",
    websiteLabel: "www.theroyallegacy.in",
    phone: "8400006545",
    deluxe: 2500,
    executive: 3000,
  },
  {
    id: 5,
    name: "Hotel SS Grand",
    address: "Misripur Guramba, Kursi Road, Lucknow",
    website: "https://sites.google.com/view/ss-grand-lucknow/home",
    websiteLabel: "SS Grand Lucknow",
    phone: "9115202115",
    deluxe: 1500,
    executive: 1800,
  },
  {
    id: 6,
    name: "Hotel Aradhna Inn",
    address: "Basha Chauraha, Kursi Road, Lucknow",
    website: "http://hotelaradhnainn.com",
    websiteLabel: "hotelaradhnainn.com",
    phone: "9112500226",
    deluxe: 1600,
    executive: 2200,
  },
];

export const technicalSessions = {
  I: {
    date: "08/10/2026",
    time: "04:15 - 05:30 PM",
    venue: "Central Auditorium",
    papers: [
      [
        17,
        "Stabilization of Thar Desert Dune Sand Using Chitosan Biopolymer",
        "Rishi Bhalavada; Dr. Ajay Bindlish",
      ],
      [
        20,
        "Erosion Characteristics of Chitosan and Kappa-Carrageenan Modified Dispersive Soil Through Pinhole Erosion Test",
        "Romana Mariyam Rasheed; Ajina Noushad; Arif Ali Baig Moghal",
      ],
      [
        23,
        "Estimation of Compressive Strength of Self-Compacting Concrete Using Machine Learning",
        "Bharti Choudhary; Surendra Kumar Saini; Praveen Kumar",
      ],
      [
        28,
        "Two-Phase Stabilization of Expansive Soil Using Lime and GGBS: Effect of Compaction Delay",
        "Himanshu; Pawan Kumar Chamling",
      ],
      [
        29,
        "Synergistic Effect of Guar gum and Coir Fibre Inclusions on Mechanical Properties of Expansive Soil",
        "Mohammed Abdul Quadeer; Mohammad Nuruddin; Romana Mariyam Rasheed; Arif Ali Baig Moghal",
      ],
      [
        30,
        "Evaluation of Fine and Coarse Bamboo Biochar for Improving the Volumetric Stability of Expansive Soil",
        "Botla Gopichand; M. Sahastra Devi; Narra Venu Madhav; Mohammad Nuruddin; Arif Ali Baig Moghal",
      ],
      [
        35,
        "Advances in Geotechnical Site Characterization Using SCPTu",
        "Sorabh Gupta; Ravi Sundaram; Venkata Abhishek Sakleshpur",
      ],
      [
        43,
        "Behavioral Insights of Piled Raft Foundation on Granular Soils under Diverse Loading Scenarios Using Geotechnical Analysis",
        "Mohd Aaqib; Mohd Iqbal Mirza; Ishfaq Ahmad",
      ],
      [
        58,
        "Comparative Assessment of Gradient Boosting and Neural Networks for Undrained Shear Strength Prediction",
        "Shraddha Sharma; Ajay Bindlish; Deepak Bhatia",
      ],
      [
        69,
        "Site characterization-based Pile Capacity calculations dilemma between IRC & IS codes: A Case Study",
        "Anurag Kapoor",
      ],
      [
        82,
        "Soil Water Characteristic Curves of Lime-Treated Lead-Contaminated Expansive Soil",
        "Suraj Kumar Bharati; Md Anisur Rahman; Arvind Kumar Jha",
      ],
      [
        100,
        "Development and Validation of a Micro-Sieving Method for Particle Size Distribution of Fine-Grained Soils",
        "Pupalwad Arti Sudam; Kadali Srinivas; D. Shashikanth; S. Kaveri; B. Kiran; P. Bhavana",
      ],
    ],
  },
  II: {
    date: "09/10/2026",
    time: "09:00 - 10:30 AM",
    venue: "Lecture Hall 2",
    papers: [
      [
        14,
        "Sustainable Stabilization of Collapsible Soil Using Rice Husk Ash and Cement: A Comparative Study on Strength",
        "Amit Patel; Kumar Venkatesh; Dr. Suresh Kumar",
      ],
      [
        32,
        "Stabilization of Clayey Soil Using Industrial and Agricultural By-products: An Experimental Study with Fly Ash and Rice Husk Ash",
        "Amresh Kumar Yadav; Dr. Bipin Prajapati; Dr. Mohd Sadat",
      ],
      [
        33,
        "Stabilization of Sodic Soils using Coir Fibre and Waste Marble Dust for Sustainable Road Subgrades",
        "Rishi Kant; Dr. Mohd Sadat",
      ],
      [
        37,
        "Sustainable Soil Stabilization using natural biopolymers: A review on Xanthan gum, Gaur gum and Chitosan",
        "Bollagani Madhuri; Sri Ramoju Shiva Prasad; Arif Ali Baig Moghal",
      ],
      [
        38,
        "Stability and Deformation Behaviour of Braced Excavations in Soft Soils: A Comprehensive Review of Geometric and Geotechnical Influencing Factors",
        "Vishnu Dharavathu; Arif Ali Baig Moghal",
      ],
      [
        56,
        "Microstructural and Geotechnical Characterization of Fly Ash Stabilized Clayey Soil for Sustainable Pavement Subgrades",
        "Shayan Khan; Vishal Kumar; Prof. Mehboob Anwer Khan; Prof. Kausar Ali",
      ],
      [
        57,
        "Transition Behaviour of Clay Fly Ash Matrix under Progressive Stone Dust Inclusion: A Density-Strength Interaction Study",
        "Shayan Khan; Vishal Kumar; Prof. Mehboob Anwer Khan; Prof. Kausar Ali",
      ],
      [
        72,
        "Numerical Modification For Over-Excavation And Replacement Of Soil Under Different Types Of Foundation",
        "Praveen Pratap Mall; Rishabh Pal; Dr. Vinay Bhushan Chauhan",
      ],
      [
        87,
        "Parametric Analysis of Dual-Layer Soil Nailing for enhanced stability of Steep Slopes",
        "Astha Dwivedi; Prakriti Srivastava; Dr. Vinay Bhushan Chauhan",
      ],
      [
        101,
        "Lime-Activated Palm Oil Fuel Ash for Sustainable Remediation of Heavy-Metal-Contaminated Soil: An Integrated Geotechnical and Environmental Assessment",
        "Muhammad Umar Musa; Aayush Kumar; Abubakar Sadiq Mohammed; Vikash Singh",
      ],
    ],
  },
  III: {
    date: "09/10/2026",
    time: "09:00 - 10:30 AM",
    venue: "Lecture Hall 3",
    papers: [
      [
        8,
        "Spatial Assessment of Population Exposure to Critical Infrastructure in the Sharda River Basin using High-Resolution Gridded Population Data",
        "Lalit Kumar Singh; Divya Srivastava; Nagendra Prasad Singh; Siddharth Srimali; Zishan Raza Khan",
      ],
      [
        10,
        "Carbon Emission Reduction in Bridge Engineering: A GIS-Based Population Co-Benefit Screening",
        "Shruti Chauhan; Rishabh Joshi; Divya Srivastava; Siddharth Srimali; Zishan Raza Khan",
      ],
      [
        41,
        "Methodological Variability in LCA of RAP",
        "Toheeb Badmus; Neha Mumtaz; Tabish Izhar",
      ],
      [
        50,
        "Rethinking GRIHA in Vastu Science (Climate-Resilient Infrastructure and Sustainable Materials) for attaining Sustainable Development Goals",
        "Mohd Asim; Muskan Khan; Umar Muhammad Musa",
      ],
      [
        62,
        "Evaluation of Salinity Variations in Water-Controlled and Rain-Dependent Soils",
        "Ali Bulama Gambo; Dr. Neha Mumtaz; Bulama Abubakar; Kurmi Maina Bukar; Mohammed Goni",
      ],
      [
        83,
        "Circular Economy in Construction: Sustainable Concrete Incorporating Paper Industry Hypo Sludge in line with SDG-9",
        "Amit Kumar Rai; Avaneesh Kumar Yadav; Vijayendra Pratap Dheeraj; Arjun Prasad; Vishal Singh Chandel",
      ],
      [
        85,
        "Analytical Evaluation of IS 11384:2022 Provisions for High-Strength and Special-Shaped Encased Composite Columns",
        "Tabish Izhar; Mohammad abid raza kazmi",
      ],
      [
        86,
        "3-Level Flying-Capacitor Integrated Motor Drive and On-Board Charger for Electric Vehicle Applications",
        "Navneet Kumar; Shubham Mishra; Vijay Laxmi Mishra",
      ],
      [
        96,
        "Assessment of Emerging Eco-Efficient Materials for Low-Carbon Transportation Geotechnics and Resilient Infrastructure",
        "Mohd Bilal Farooqui; Neha Mumtaz; Balendu Shekher Giri; Tabish Izhar; Syed Aqeel Ahmad",
      ],
      [
        111,
        "Bearing Capacity and Design Recommendations for Strip Footings Adjacent to Soil-Nailed Slopes Using Adaptive Finite Element Limit Analysis",
        "Hamza Imaran; Aayush Yadav; Vikash Singh",
      ],
      [
        113,
        "Sustainable Subgrade Stabilization of Black Cotton Soil Using Waste Brick Bat Powder and Natural Gogu Fiber",
        "Rahul R. Balekundri; Niveditha Madinur; Srinivas F Chitragar",
      ],
    ],
  },
  IV: {
    date: "09/10/2026",
    time: "09:00 - 10:30 AM",
    venue: "Block-E, E119",
    papers: [
      [
        89,
        "Numerical Investigation of Double-Layer Confined Self-Compacting Concrete Columns for Transportation Infrastructure under Monotonic Lateral Loading",
        "Mohd. Kashif Khan; Syed Aqeel Ahmad; Syed Kaleem Afrough Zaidi",
      ],
      [
        90,
        "Seismic Vulnerability and Economic Viability of Large-Span Flat Slab Systems in High-Intensity Earthquakes: A Meta-Analytical Review",
        "Tabish Izhar; Niraj Kumar Pandey",
      ],
      [
        93,
        "Post-use Fate of Oil-Spill Sorbents: Reuse, Regeneration, Resource Recovery and Circular Decision Pathways",
        "Ankit Gupta; Neha Mumtaz; Balendu Shekher Giri; Tabish Izhar; Syed Aqeel Ahmad",
      ],
      [
        103,
        "Confinement of Reinforced Concrete Columns: Evolution of Confinement Models and Recent Developments in Double-Layer Transverse Reinforcement",
        "Mohd. Kashif Khan; Syed Aqeel Ahmad; Syed Kaleem Afrough Zaidi",
      ],
      [
        104,
        "Effect of Appurtenances on Hydraulic Jump Behavior in Abruptly Expanding Rectangular Channels",
        "Sumit Gandhi",
      ],
      [
        106,
        "Experimental Investigation of Defect Geometry and Hydraulic Head Effects in Leakage through Thin LLDPE Geomembranes",
        "Preetam Kumar Shukla; Manoo Singh; Vikash Singh",
      ],
      [
        107,
        "Seismic Stability and Geohazard Assessment of Strip Footings over Unlined Horseshoe-Shaped Tunnels Using Adaptive Finite Element Limit Analysis",
        "Nabeel Ahmad; Aayush Kumar; Vikash Singh",
      ],
      [
        109,
        "Photocatalytic Materials and Technologies for Wastewater Treatment: A Comprehensive Review of Photocatalysts, Reactor Systems, Mechanisms, Performance and Future Perspectives",
        "Syed Shuja Askari; Neha Mumtaz; Tabish Izhar",
      ],
      [
        110,
        "Development of Mechanical Properties of Concrete Composites by using Waste plastic and clothes",
        "Priya Sharma; Indrajeet Singh",
      ],
    ],
  },
  V: {
    date: "09/10/2026",
    time: "04:10 - 05:40 PM",
    venue: "Central Auditorium",
    papers: [
      [
        12,
        "Performance Evaluation of Geocell Retaining Wall with Coconut shell-soil composite supporting Highway Embankment",
        "Somnath Paul; Dipankar Sarkar; Rajib Saha",
      ],
      [
        13,
        "Vibration Analysis of Buildings Subjected to Railway-Induced Ground Motion: A Numerical and Parametric Study",
        "Abdul Kafeel; Md. Muslim Ansari; Ajay Chourasia; R Pradeep Kumar",
      ],
      [
        21,
        "Behavior of Ballast Mixed With Waste Tire Rubber Under Direct Shear Conditions: A Discrete Element Method (DEM) Approach",
        "Md Hussain; Md Naquib Alam; Syed Khaja Karimullah Hussaini",
      ],
      [
        45,
        "Integrated Stability and Settlement Assessment of an Ash Dyke under Variable Hydraulic and Construction Conditions",
        "Saurabh Singh Katheriya; Vijay Kumar",
      ],
      [
        52,
        "Runout Prediction of Seismically Induced Debris Flows in Structurally Controlled Himalayan Slopes Using the Discrete Element Method",
        "Sudha Gautam; Ankesh Kumar",
      ],
      [
        59,
        "Geotechnical Characterization and Liquefaction Screening of Ganga and Yamuna Riverbank Alluvium in Prayagraj",
        "Aditay Ratan Singh; Vijay Kumar",
      ],
      [
        66,
        "Distress Assessment of Slope Behaviour under Blast-Induced Ground Motion",
        "Manish Kumar Meena; Shashank Bhatnagar; Manojit Samanta",
      ],
      [
        71,
        "Shear Behaviour of Geogrid Reinforced Rubber Coated Ballast at the Interface of Ballast-SubBallast Layer",
        "Md Naquib Alam; Md Hussain; Syed Khaja Karimullah Hussaini",
      ],
      [
        73,
        "X-Y-Y' Calculus from Soil Consolidation to All Dynamical Systems",
        "Sudhir Kumar Tewatia; Anttriksh Tewatia; Kanishck Tewatia",
      ],
      [
        80,
        "Tunnelling-Induced Ground Deformation Analysis in Cohesionless Soil: An Experimental and Numerical Investigation",
        "Piyush Raj; Manojit Samanta",
      ],
    ],
  },
  VI: {
    date: "09/10/2026",
    time: "04:10 - 05:40 PM",
    venue: "Lecture Hall 2",
    papers: [
      [
        9,
        "A Method of Estimation of Pothole area on Flexible Road Pavement using Machine Learning Driven Approach",
        "Sumana Chakraborty; Arpitam Chatterjee; Partha Pratim Biswas",
      ],
      [
        15,
        "Use of Waste Engine Oil and Waste Vegetable Oil as Sustainable Alternatives to Conventional Non-Renewable Fluxing Agents to Hard Petroleum Pitch for Production of Bitumen for Road Applications",
        "Venkata Akhilesh Danam; Sidhyanath Panda; Rahul Thakur; Amaranatha Reddy Muppireddy",
      ],
      [
        16,
        "Linking Laboratory Characterization to Accelerated Pavement Testing: A Framework for Pavement Material Selection and Design",
        "Sidhyanath Panda; Venkata Akhilesh Danam; Vinayak Sahu; Amaranatha Reddy Muppireddy",
      ],
      [
        22,
        "Waste-to-Resource Materials for Sustainable and Resilient Transportation Infrastructure Development",
        "Dr. Snehal Abhyankar; Dr. Sagar Turkane",
      ],
      [
        24,
        "Performance Assessment of Reclaimed Asphalt Pavement Mixtures Rejuvenated with Waste Cooking Oil",
        "Aditya Ranjan Patra; Sanapala Jogarao; Aditya Kumar Das; Mahabir Panda",
      ],
      [
        27,
        "Finite Element Analysis of Proximity-Induced Interaction Between Horseshoe-Shaped and Circular TBM Tunnels in Soft Ground",
        "Safoora Hafeez; Mohd Bilal; Dr. Md. Rehan Sadique; Dr. Zaid Mohammad",
      ],
      [
        31,
        "TrackSens: An Optical Fiber-Based System for Real-Time Monitoring of Railway Track Joint Integrity",
        "Barad Shreyansh Bhaveshbhai; Dr. Pandya Alpesh Arvindbhai",
      ],
      [
        40,
        "Influence of Subgrade Stiffness and Wheel Load Position on The Structural Response of Paver Block Pavement System",
        "Anshuman Maurya; Dr. Shalinee Shukla; Dr. Priyaranjan Pal",
      ],
      [
        63,
        "Cautious Controlled Blasting in Hard Rock for Rock Excavation of High-Rise Building Project: Challenges and Solutions",
        "Manoj D. Gurharikar",
      ],
      [
        94,
        "Comparison of Ground Improvement Measures for Mitigating Railway-Induced Vibrations",
        "Utkarsh Mishra; V. A. Sawant",
      ],
      [
        102,
        "A 3D FEM Analysis of Ballastless Track Supported by Pile Foundation",
        "Rajat Verma; Utkarsh Mishra; Vikash Singh; Syed Aqeel Ahmad",
      ],
    ],
  },
  VII: {
    date: "09/10/2026",
    time: "04:10 - 05:40 PM",
    venue: "Lecture Hall 3",
    papers: [
      [
        26,
        "Behavior of Slopes under Strip Footings in Seismic Conditions: State of Art and Critical Review",
        "Mridul Goel; Aparna Tiwari; Vaibhav Anand; Pawan Sahu; Abhishek Prakash Paswan",
      ],
      [
        34,
        "A Review on Mechanical and Durability Properties of Self-healing Concrete Pavement Incorporating Different Bacterial Solutions",
        "Dharmendra Kumar Singh; Ajay Kumar Mandrawalia; Aryan Kumar Raj; Deepa Bisht",
      ],
      [
        36,
        "Failure Mechanisms in Reinforced Soil Slopes for Transportation Infrastructure: A Review of Case Histories and Design Implications",
        "Shiny Lilian Geddam; Arif Ali Baig Moghal",
      ],
      [
        46,
        "Optimisation of Blending Parameters and Polymer Content for PLA-Modified Asphalt Binder Using Storage Stability and Fluorescence Morphology",
        "Ishfaq Ahmad; Vivek; Mohd Aaqib",
      ],
      [
        51,
        "Characteristics Evaluation of High Performance Concrete With Nano Silica And Nano Clay: A Comprehensive Review",
        "Siddharth Pastariya; Dr. Umesh Pendharkar",
      ],
      [
        55,
        "Enhance the Quality and Performance of Rigid Pavement Using Fibers",
        "Pinki Meena; Praveen Kumar",
      ],
      [
        60,
        "Potential of Recycled Concrete Aggregate Powder as a Filler in Bituminous Mix: A Review Paper",
        "Sundram Gupta; Deepak Prasad",
      ],
      [
        61,
        "Analysis of Geo-Reinforced Embankment on Soft Soil",
        "Siddharth Prakash; Vinayak Mishra; Deepika Singh; Divyansh Singh; Vinay Bhushan Chauhan",
      ],
      [
        64,
        "Laboratory Investigation on the High Temperature Performance of SMA Mixes Using Chitin Modified Bitumen Binder",
        "Suraj Kumar Nayak; Chirag Asandas Gurubani; Aditya Kumar Das; Mahabir Panda",
      ],
      [
        81,
        "Synergistic Effects of Macro Calcium Carbonate, Metakaolin and Nano TiO2 on the Durability, Workability and Mechanical Performance of Sustainable Concrete",
        "Nadeem Nisar; Dr. Ibadur Rahman; Prof. Khalid Moin",
      ],
      [
        84,
        '"Zero-Drop" Manhole Retrofitting for Urban Indian Roads',
        "Tabish Izhar; Neha Mumtaz; Shoeb Akhtar",
      ],
    ],
  },
  VIII: {
    date: "10/10/2026",
    time: "09:00 - 10:30 AM",
    venue: "Block-E, E119",
    papers: [
      [
        74,
        "Full-Depth Reclamation of Pavements: A Comprehensive Review of Materials, Stabilization, Mix Design, Performance, Structural Response, and Sustainability",
        "Divyendu Kumar Singh; Samreen Bano; Syed Aqeel Ahmad; Vikash Singh",
      ],
      [
        75,
        "Experimental Investigation of the Strength, Durability, and Flexural Performance of Stabilized Reclaimed Pavement Materials for Full-Depth Reclamation",
        "Divyendu Kumar Singh; Samreen Bano; Syed Aqeel Ahmad; Vikash Singh",
      ],
      [
        76,
        "Impact of Incorporation of Crushed Granite into Mechanical Properties of Concrete Mix for Rigid Pavement",
        "Saumya Yadav; Vikash Singh; Aayush Kumar; Prakhar Tyagi",
      ],
      [
        77,
        "Eco-Efficient Concrete Design Using Recycled Fine Aggregates and Micro Silica: A Performance-Based Study",
        "Pratikshit Singh; Vikash Singh; Samreen Bano; Aayush Kumar",
      ],
      [
        78,
        "Mechanical Performance of Concrete Incorporating Induction Furnace Slag as Fine Aggregate Replacement",
        "Neelam Verma; Vikash Singh; Samreen Bano; Aayush Kumar",
      ],
      [
        79,
        "Mechanical and Durability Performance of Concrete with Partial Replacement of Cement by Finely Ground Waste Glass Powder",
        "Akash Gupta; Vikash Singh; Mudassir Ali Khan; Ahmad Rashiq",
      ],
      [
        92,
        "Application of organic waste materials in sustainable pavement and geotechnical engineering",
        "Aditya Dubey; Neha Mumtaz; Tabish Izhar",
      ],
      [
        97,
        "Sustainability assessment of recycled concrete aggregate for building construction",
        "Aman Kumar Prajapati; Vikash Singh; Vinay Bhushan Chuhan; Rajat Verma",
      ],
      [
        115,
        "Durability Performance of Concrete Incorporating Mechanically Processed Recycled Concrete Aggregate: Linking Abrasion Intensity with Chloride Penetration and Water",
        "Usman Ali; Zishan Raza Khan; Vikash Singh",
      ],
    ],
  },
  IX: {
    date: "10/10/2026",
    time: "09:00 - 10:30 AM",
    venue: "Lecture Hall 2",
    papers: [
      [
        11,
        "Freeze-Thaw Response of EICP-Stabilized Dredged Soil for Sustainable Ground Improvement Application",
        "Rifahat Muntaha; Bashir Ahmad Mir",
      ],
      [
        19,
        "Freeze-Thaw Performance of Guar Gum-Stabilized Sela Pass Soil",
        "Chukhu Tagar; Ajanta Kalita; Arindam Dey",
      ],
      [
        47,
        "Effect Of Rbi Grade-81 On Strength Characteristics and Microstructural Analysis of Clay Soil",
        "Dharmendra Singh; Vijay Kumar; Ayush Mittal; Vinod Kumar Vishwakarma; Umashankar Prajapati",
      ],
      [
        48,
        "Strength Improvement of Expansive Soils Treated with Combined Sugarcane Bagasse Ash and Rice Husk Ash",
        "Dharmendra Singh; Ayush Mittal; Ramesh Kumar Verma; Amit Singh",
      ],
      [
        42,
        "Application of Machine Learning Techniques for Analysis of Moving Loads on Beams Supported by Elastic Foundation: A Study for Railway Embankment",
        "Susmita Panda",
      ],
      [
        49,
        "Influence of Proximity to the Structure on Predominant Frequency of Surrounding Soil through Microtremor-Based HVSR",
        "Faizah Amin; Falak Zahoor; Aadil Saleem Bhat",
      ],
      [
        53,
        "Strength Characteristics of Expansive Soil Reinforced with Non-Woven Geotextiles: A Review",
        "Dharmendra Singh; Umashankar Prajapati; Vinod Kumar Vishwakarma; Ayush Mittal; Ramesh Kumar Verma; Amit Singh",
      ],
    ],
  },
  X: {
    date: "10/10/2026",
    time: "09:00 - 10:30 AM",
    venue: "Lecture Hall 3",
    papers: [
      [
        54,
        "Microstructural And Geotechnical Behaviour of Expansive Soil Stabilized with Sugarcane Bagasse Ash: A Review",
        "Dharmendra Singh; Umashankar Prajapati; Vinod Kumar Vishwakarma; Ayush Mittal; Ramesh Kumar Verma; Amit Singh",
      ],
      [
        67,
        "Enhancing the Geotechnical Properties of Soil with Cementitious Additives",
        "Abhishek Arya; Amit Mishra",
      ],
      [
        68,
        "Experimental Investigation on the Modification of Soil Properties Using Fly Ash and Quarry Dust",
        "Abhishek Arya; Amit Mishra",
      ],
      [
        91,
        "Effect Of Fly Ash and Waste Glass as Partial Replacement of Cement and Sand on Strength and Durability of Concrete",
        "Ayush Mittal; Dharmendra Singh; Ramesh Kumar Verma; Amit Singh; Dhananjaya Singh Chauhan",
      ],
      [
        98,
        "An Experimental Investigation of non-Newtonian Debris Flow by Small Scale wave Flume",
        "Mudassir Ali Khan; Zahiraniza Mustaffa; Vikash Singh",
      ],
      [
        99,
        "Multiphase Modelling of Debris Flow Impact on Exposed Pipeline",
        "Mudassir Ali Khan; Zahiraniza Mustaffa; Vikash Singh; Harshit Shrivastav",
      ],
    ],
  },
};

export const schedule = [
  {
    date: "Day 1 (October 8, 2026) - Thursday",
    events: [
      {
        time: "08:30 - 09:30 AM",
        activity: "Registration",
        venue: "Central Auditorium",
      },
      {
        time: "09:30 - 10:00 AM",
        activity: "Networking Tea",
        venue: "Central Auditorium Basement",
      },
      {
        time: "10:00 - 11:30 AM",
        activity: "Inaugural Session",
        venue: "Central Auditorium",
      },
      {
        time: "11:30 AM - 12:00 PM",
        activity: "TG-SMART Expo",
        venue: "Exhibition Area",
      },
      {
        time: "12:00 - 12:45 PM",
        activity:
          "Plenary Lecture I - Prof. Tatsuya Ishikawa (Hokkaido University, Japan)",
        topic:
          "Geotechnical Framework for GPR-Based Assessment of Ballast Fouling and Rational Ballast Renewal Decisions",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "12:45 - 01:20 PM",
        activity:
          "Keynote Lecture I - Prof. Arif Ali Baig Moghal (NIT Warangal)",
        topic:
          "Ground Improvement with Biopolymers: Principles, Performance, and Sustainability",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "12:00 - 12:45 PM",
        activity:
          "Plenary Lecture I - Prof. Tatsuya Ishikawa (Hokkaido University, Japan)",
        topic:
          "Geotechnical Framework for GPR-Based Assessment of Ballast Fouling and Rational Ballast Renewal Decisions",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "12:45 - 01:20 PM",
        activity:
          "Keynote Lecture I - Prof. Arif Ali Baig Moghal (NIT Warangal)",
        topic:
          "Ground Improvement with Biopolymers: Principles, Performance, and Sustainability",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "01:20 - 02:00 PM",
        activity: "Lunch Break & Exhibition Visit",
        venue: "Central Auditorium Basement",
      },
      {
        time: "02:00 - 02:35 PM",
        activity:
          "Keynote Lecture II - Dr. Kanwar Singh (Chief Scientist, CSIR-CRRI, New Delhi)",
        topic: "Construction of underpass using Box Jacking with Soil Nailing",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "02:00 - 02:35 PM",
        activity:
          "Keynote Lecture II - Dr. Kanwar Singh (Chief Scientist, CSIR-CRRI, New Delhi)",
        topic: "Construction of underpass using Box Jacking with Soil Nailing",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "02:35 - 03:20 PM",
        activity:
          "Corporate Presentations: Arun Soil Lab Pvt. Ltd.; Pioneer Foundation Engineers Private Limited; Techfab (India) Industries Limited",
        venue: "Central Auditorium",
      },
      {
        time: "03:20 - 03:40 PM",
        activity: "Networking Tea",
        venue: "Central Auditorium Basement",
      },
      {
        time: "03:40 - 04:15 PM",
        activity:
          "Keynote Lecture III - Dr. R. P. Singh (National High-Speed Rail Corporation Limited)",
        topic:
          "Geotechnical Investigation for Delhi-Patna High Speed Rail Project: A Paradigm Shift",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "04:15 - 05:30 PM",
        activity: "Technical Session I",
        venue: "Central Auditorium",
      },
      {
        time: "03:40 - 04:15 PM",
        activity:
          "Keynote Lecture III - Dr. R. P. Singh (National High-Speed Rail Corporation Limited)",
        topic:
          "Geotechnical Investigation for Delhi-Patna High Speed Rail Project: A Paradigm Shift",
        venue: "Central Auditorium",
        highlight: true,
      },
    ],
  },
  {
    date: "Day 2 (October 9, 2026) - Friday",
    events: [
      {
        time: "08:30 - 09:00 AM",
        activity: "Registration",
        venue: "Central Auditorium Foyer",
      },
      {
        time: "09:00 - 10:30 AM",
        activity: "Parallel Technical Sessions (II-IV)",
        venues: [
          "Session II - Central Auditorium, Hall 2",
          "Session III - Central Auditorium, Hall 3",
          "Session IV - Block-E, E119",
        ],
      },
      {
        time: "10:30 - 11:15 AM",
        activity:
          "Plenary Lecture II - Prof. Lindung Zalbuin Mase (University of Bengkulu, Indonesia)",
        topic:
          "Flow and Cyclic Mobility Liquefactions during A Great Indonesian Earthquake 2018 in Palu, Indonesia",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "11:15 - 11:50 AM",
        activity: "Keynote Lecture IV - Dr. Ambika Behl (CSIR-CRRI, New Delhi)",
        topic: "Waste-to-Resource Materials for Sustainable Roads",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "10:30 - 11:15 AM",
        activity:
          "Plenary Lecture II - Prof. Lindung Zalbuin Mase (University of Bengkulu, Indonesia)",
        topic:
          "Flow and Cyclic Mobility Liquefactions during A Great Indonesian Earthquake 2018 in Palu, Indonesia",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "11:15 - 11:50 AM",
        activity: "Keynote Lecture IV - Dr. Ambika Behl (CSIR-CRRI, New Delhi)",
        topic: "Waste-to-Resource Materials for Sustainable Roads",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "11:50 AM - 12:20 PM",
        activity: "Corporate Presentation",
        venue: "Central Auditorium",
      },
      {
        time: "12:20 - 01:30 PM",
        activity: "Lunch Break & Exhibition Visit",
        venue: "Central Auditorium Basement",
      },
      {
        time: "01:30 - 02:05 PM",
        activity:
          "Keynote Lecture V - Prof. Neelima Satyam Devarakonda (IIT Indore)",
        topic:
          "Performance evaluation and deformation behaviour of reinforced paved structure",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "01:30 - 02:05 PM",
        activity:
          "Keynote Lecture V - Prof. Neelima Satyam Devarakonda (IIT Indore)",
        topic:
          "Performance evaluation and deformation behaviour of reinforced paved structure",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "02:05 - 02:35 PM",
        activity:
          "Corporate Presentations: Cemindia Projects Limited / Strata Geosystems (India) Pvt. Ltd.",
        venue: "Central Auditorium",
      },
      {
        time: "02:35 - 03:10 PM",
        activity:
          "Keynote Lecture VI - Prof. M. Amaranatha Reddy (IIT Kharagpur)",
        topic:
          "Research initiatives for improving existing pavement design and maintenance approaches for Indian Highways",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "02:35 - 03:10 PM",
        activity:
          "Keynote Lecture VI - Prof. M. Amaranatha Reddy (IIT Kharagpur)",
        topic:
          "Research initiatives for improving existing pavement design and maintenance approaches for Indian Highways",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "03:10 - 03:30 PM",
        activity: "Networking Tea",
        venue: "Central Auditorium Basement",
      },
      {
        time: "03:30 - 04:05 PM",
        activity:
          "Keynote Lecture VII - Dr. Sreevalsa Kolathayar (NIT Surathkal)",
        topic: "Sustainable Geosolutions for Disaster Risk Reduction",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "04:05 - 05:35 PM",
        activity: "Parallel Technical Sessions (V-VII)",
        venues: [
          "Session V - Central Auditorium, Hall 2",
          "Session VI - Central Auditorium, Hall 3",
          "Session VII - Block-E, E119",
        ],
      },
      {
        time: "03:30 - 04:05 PM",
        activity:
          "Keynote Lecture VII - Dr. Sreevalsa Kolathayar (NIT Surathkal)",
        topic: "Sustainable Geosolutions for Disaster Risk Reduction",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "06:00 - 07:00 PM",
        activity: "Cultural Events",
        venue: "Central Auditorium",
      },
    ],
  },
  {
    date: "Day 3 (October 10, 2026) - Saturday",
    events: [
      {
        time: "09:00 - 10:30 AM",
        activity: "Parallel Technical Sessions (VIII-X)",
        venues: [
          "Session VIII - Central Auditorium, Hall 2",
          "Session IX - Central Auditorium, Hall 3",
          "Session X - Central Auditorium, Hall 4",
        ],
      },
      {
        time: "10:45 - 11:30 AM",
        activity:
          "Plenary Lecture III (Online) - Prof. Praveen Kumar (IIT Roorkee)",
        topic:
          "Utilization of waste plastic for the construction of flexible roads",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "10:45 - 11:30 AM",
        activity:
          "Plenary Lecture III (Online) - Prof. Praveen Kumar (IIT Roorkee)",
        topic:
          "Utilization of waste plastic for the construction of flexible roads",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "11:30 - 11:50 AM",
        activity: "Networking Tea",
        venue: "Central Auditorium Basement",
      },
      {
        time: "11:50 AM - 12:25 PM",
        activity:
          "Keynote Lecture VIII - Prof. Ramanathan Ayothiraman (IIT Tirupati)",
        topic:
          "Waste Materials in Soil Reinforcement Applications for Sustainable Engineering",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "11:50 AM - 12:25 PM",
        activity:
          "Keynote Lecture VIII - Prof. Ramanathan Ayothiraman (IIT Tirupati)",
        topic:
          "Waste Materials in Soil Reinforcement Applications for Sustainable Engineering",
        venue: "Central Auditorium",
        highlight: true,
      },
      {
        time: "12:25 - 12:55 PM",
        activity: "Cureus Journal Session",
        venue: "Central Auditorium",
      },
      {
        time: "12:55 - 01:10 PM",
        activity: "Corporate Presentation: Geoquest India Pvt. Ltd.",
        venue: "Central Auditorium",
      },
      {
        time: "01:10 - 02:00 PM",
        activity: "Lunch Break & Exhibition Visit",
        venue: "Central Auditorium Basement",
      },
      {
        time: "02:00 - 03:30 PM",
        activity: "Valedictory Session",
        venue: "Central Auditorium",
      },
      {
        time: "03:30 - 04:00 PM",
        activity: "Closing Tea & Networking",
        venue: "Central Auditorium Basement",
      },
    ],
  },
];
